import styled from 'styled-components'

export const DaysInfoStyled = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    width: 52px;
    height: 19px;
    border-radius: 3px;
    color: ${ ({ theme }) => theme.whiteTwo};
    background-color: ${ ({ color }) => color};
    margin-left: 10px;
`